import { h } from "vue";
import { g as n } from "./DefaultValues-DOBkctU1.js";
const a = ({ props: o, svgNodeAttrs: s, childrenNodes: i }) => {
  const t = {
    ...n(),
    //Removing undefined props
    ...Object.entries(o).reduce((r, [g, e]) => (e && (r[g] = e), r), {})
  };
  return h(
    "svg",
    {
      height: t.height,
      //Setting default height (20px)
      width: t.width,
      //Setting default width (20px)
      ...s
    },
    i
  );
};
export {
  a as s
};
